import { InputGroup, InputLeftAddon, Select } from "@chakra-ui/react";
import { generateArrayOfYears } from "../../utils";
import { t } from "i18next";

function YearSelector({ selectedYear, handleYearSelection, groupStyles = {} }) {
  return (
    <InputGroup display="flex" alignItems="center" width="200px" marginBlock={4} {...groupStyles}>
      <InputLeftAddon children={t("year")} fontWeight="semibold" />
      <Select
        backgroundColor="white"
        borderRadius="none"
        value={selectedYear}
        onChange={(e) => handleYearSelection(e.target.value)}
      >
        {generateArrayOfYears().map(year => <option key={year} value={year}>{year}</option>)}
      </Select>
    </InputGroup>
  )
}

export default YearSelector;